export default {
      id: "notifications__max-speed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__max-speed",
      toString: function () {
        return this.url;
      }
    }